import { MenuNode } from "../angular-ui-common/base-types";

export const BASE_NAVIGATION_TREE: MenuNode[] = [
    {
        id: "home",
        url: '/home',
        requiredAuthorities: [],
        disabled: false,
        showInPublicMenu: false,
        showInPrivateMenu: false,
        navigable: true
    }, {
        id: "about",
        url: '/about',
        requiredAuthorities: [],
        disabled: false,
        showInPublicMenu: false,
        showInPrivateMenu: false,
        navigable: true
    }, {
        id: "login",
        url: '/login',
        requiredAuthorities: [],
        disabled: false,
        showInPublicMenu: false,
        showInPrivateMenu: false,
        navigable: true
    }, {
        id: "sign_up",
        url: '/sign-up',
        requiredAuthorities: [],
        disabled: false,
        showInPublicMenu: false,
        showInPrivateMenu: false,
        navigable: true
    }, {
        id: "set_password",
        url: '/set-password',
        requiredAuthorities: [],
        disabled: false,
        showInPublicMenu: false,
        showInPrivateMenu: false,
        navigable: true
    }, {
        id: "reset_password",
        url: '/reset-password',
        requiredAuthorities: [],
        disabled: false,
        showInPublicMenu: false,
        showInPrivateMenu: false,
        navigable: true
    }
]
